// extracted by mini-css-extract-plugin
export default {"container":"ModalDownloadBackupDataFailed_container__7um5L","description":"ModalDownloadBackupDataFailed_description__NEBjZ"};